/**
 * Clickwork products
 */
import { functions } from '@/firebaseConfig'

const state = {
  products: [],
}

const getters = {
  clickworkProducts: (state) => {
    return state.products
  }
}

const mutations = {
  setClickworkProducts(state, newValue) {
    state.products = newValue
  }
}

const actions = {
  async getClickworkProducts({ commit, state }) {
    if (state.products.length !== 0) {
      return
    }
    const getProducts = functions.httpsCallable('products-list')
    try {
      const response = await getProducts()
      commit('setClickworkProducts', response.data)
    } catch (error) {
      console.error(error)
    }
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}